import React from 'react';
import { Select } from 'antd';
import SelectPaginacao from '../selectPaginacao';

export default function SelectProduto(props) {


  return (
    <SelectPaginacao
      url={"Produto/ListaProdutoFiltro"}
      form={props.form}
      nameValue={props.name}
      onChangeFunction={!!props.onChange ? props.onChange : () => { }}
      onBlurFunction={!!props.onBlur ? props.onBlur : () => { }}
      onSelectFunction = {!!props.onSelect ? props.onSelect : () => { }}
      nameLabel={props.ordem}
      atualizaComponente={!!props.atualizaComponente ? props.atualizaComponente : false}
      allowClear={!!props.allowClear ? props.allowClear : false}
      disabled={!!props.disabled}
      placeholder={!!props.placeholder ? props.placeholder : "Selecione um produto"}
      filtroExtra={props.filtroExtra}
      filtroPesq={props.filtroPesq}
      setListaDados={!!props.setListaDados ? props.setListaDados : null}
      selecionarRegUnico={!!props.selecionarRegUnico ? props.selecionarRegUnico : null}
      conteudo={(produto) => (
        <Select.Option value={!!props.valueKey ? produto.key : produto.pro_id} key={produto.key}>
          {produto.pro_codigo} - {produto.pro_descricao}
          {(!!props.detalhes ? <br /> : '')}
          {(!!props.detalhes && !!produto.pro_ean ? `EAN/GTIN: ${produto.pro_ean}` : "")}
          {(!!props.detalhes && (!!produto.descricaograde && !!produto.pro_ean) ? <br /> : '')}
          {(!!props.detalhes && !!produto.descricaograde ? `Grade: ${produto.descricaograde}` : "")}
          {(!!props.detalhes && (!!produto.prg_ean && ((!!produto.pro_ean && !!!produto.descricaograde) || !!produto.descricaograde)) ? <br /> : '')}
          {(!!props.detalhes && !!produto.prg_ean ? `EAN/GTIN Grade: ${produto.prg_ean}` : "")}
          {(!!props.detalhes && (!!produto.pro_codigoetiqueta && ((!!produto.pro_ean && !!!produto.descricaograde) || !!produto.prg_ean)) ? <br /> : '')}
          {(!!props.detalhes && !!produto.pro_codigoetiqueta ? `Cód.Etiqueta: ${produto.pro_codigoetiqueta}` : "")}
          {(!!props.detalhes && (!!produto.estoque &&
            (((!!produto.pro_ean && !!!produto.descricaograde) || !!produto.pro_codigoetiqueta))
            || (!!produto.prg_ean && !!!produto.pro_codigoetiqueta)
          ) ? <br /> : '')}
          {(!!props.detalhes && !!produto.estoque ? `Qtde Estoque: ${produto.estoque}` : "")}
        </Select.Option>
      )}
    />
  )
}
